import type { Row } from "@tanstack/react-table"
import type { ReactElement } from "react"

import { getPurchaseOrderProductTableColumns } from "../../PurchaseOrder/ProductAdded/components/getPurchaseOrderProductTableColumns"

import { AerosBaseTable } from "@/components/Tables/Aeros/components/AerosBaseTable"
import type { Order, OrderLine } from "@/graphql/codegen/graphql"

export const PurchaseOrdersExpandedRowDetails = (row: Row<OrderLine | Order>): ReactElement => {
  const showCompanyName = Boolean(row?.original?.product?.company?.name)
  const columns = getPurchaseOrderProductTableColumns({
    isReadOnly: true,
    showCompanyName,
    order: row.original as Order,
  })
  const products = ("orderLines" in row.original ? row.original.orderLines : [row.original]) ?? []

  return (
    <div className='p-6'>
      <AerosBaseTable<OrderLine | Order>
        features={{
          tanstackOptions: {
            columns,
            data: products,
          },
        }}
        slotProps={{
          headerCell: { className: "bg-primary-100" },
        }}
        noDataMessage='No products found'
      />
    </div>
  )
}
